@if (notificationsNumber > 0) {
    <p [className]="className +' '+environment.data.brand+'-icon'">
        @if (notificationsNumber <= 5) {
            <span style="color: #FFFFFF !important;">{{ notificationsNumber }}</span>
        }
        @if (notificationsNumber > 5) {
            <span style="color: #FFFFFF !important;">5+</span>
        }
    </p>
}

